import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'ui-action-result',
  templateUrl: './ui-action-result.component.html',
  styleUrls: ['./ui-action-result.component.scss']
})
export class UiActionResultComponent {

  @Input() successTransKey: string;
  @Input() errorTransKey: string;
  @Input() timeout: number = 1000;

  @Input() set source(src: Promise<any> | Observable<any> | boolean) {
    if (src === null || src === undefined) {
      return;
    }

    if (src && (src as Promise<any>).then && (src as Promise<any>).catch) {
      (src as Promise<any>)
        .then(() => {
          this.status = true;
          this.runTimeout();
        })
        .catch(() => {
          this.status = false;
        });
    }

    if (src && (src as Observable<any>).subscribe) {
      (src as Observable<any>)
        .subscribe(
          () => {
            this.status = true;
            this.runTimeout();
          },
          () => {
            this.status = false;
          });
    }

    this.status = Boolean(src);
    if (this.status) {
      this.runTimeout();
    }
  }

  public status: boolean;

  constructor() {
  }

  public runTimeout() {
    setTimeout(() => this.status = null, this.timeout);
  }
}
